import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ea36ebbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "header-community-site"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "text-on-image fw-bold w-bold mb-lg-0" }
const _hoisted_4 = {
  key: 1,
  class: "d-flex justify-content-center mb-lg-4 mb-3 only-text-header"
}
const _hoisted_5 = { class: "pb-3 fw-bold" }
const _hoisted_6 = {
  key: 2,
  class: "artical-list"
}
const _hoisted_7 = {
  key: 3,
  class: "artical-list"
}
const _hoisted_8 = { key: 4 }
const _hoisted_9 = {
  key: 0,
  class: "text-no-artical fw-bold text-center mb-5"
}
const _hoisted_10 = { class: "mt-3 d-flex justify-content-center" }
const _hoisted_11 = { class: "d-flex align-items-center ms-3" }

import ArticalItem from '@/views/user/community_site/components/artical_item.vue'
import Pagination from '@/components/pagination/index.vue'
import SelectCustom from '@/components/select-custom/index.vue'
import ArticalSkeleton from '@/components/skeletons/ArticalSkeleton.vue'

import { ref, computed, ComputedRef, onMounted, watch } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { COMMUNITY_SITE_STORE, COMMUNITY_STORE } from '@/store/constants'
import { isEmpty } from 'lodash'
import { addCommunitySiteHeaderParams } from '@/use/usePath'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const route = useRoute()
const router = useRouter()

const dataSelectRecordPerPage = ref([
  { value: '10', label: '10' },
  { value: '20', label: '20' },
  { value: '30', label: '30' },
])

const postsData = computed<ComputedRef>(() => store.getters[COMMUNITY_SITE_STORE.GETTERS.COMMUNITY_SITE_POSTS])

const communityInfo = computed(() => store.getters[COMMUNITY_STORE.GETTERS.COMMUNITY_INFO])

const getPosts = async (params: any) => {
  if (isEmpty(params)) {
    params = {
      page_of_number: route.query?.page_of_number ? route.query?.page_of_number : 10,
      page: route.query?.page ? route.query?.page : 1,
    }
  }
  await store.dispatch(COMMUNITY_SITE_STORE.ACTIONS.GET_COMMUNITY_SITE_POSTS, {
    community_id: route?.params?.id,
    params: params,
  })
}

onMounted(async () => {
  getPosts({})
  await store.dispatch(COMMUNITY_STORE.ACTIONS.SET_COMMUNITY_INFO, router.currentRoute.value.params?.id)
})

watch([() => route.query?.page, () => route.query?.page_of_number], () => {
  var params = {
    page_of_number: route.query?.page_of_number ? route.query?.page_of_number : 10,
    page: route.query?.page ? route.query?.page : 1,
  }
  getPosts(params)
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(communityInfo)?.community_site_image_url)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("img", {
            src: _unref(addCommunitySiteHeaderParams)(_unref(communityInfo)?.community_site_image_url),
            alt: ""
          }, null, 8, _hoisted_2),
          _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(communityInfo)?.community_site_header_text ? _unref(communityInfo).community_site_header_text : ''), 1)
        ]))
      : (_unref(communityInfo)?.community_site_header_text)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("h1", _hoisted_5, _toDisplayString(_unref(communityInfo).community_site_header_text), 1)
          ]))
        : _createCommentVNode("", true),
    (!_unref(postsData).loadingPosts)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(postsData).posts, (post) => {
            return (_openBlock(), _createElementBlock("div", {
              key: post.id,
              class: "artical-item"
            }, [
              _createVNode(_component_router_link, {
                to: `/${_unref(route).path.split('/')[1]}/communities/${_unref(route)?.params?.id}/community_site_posts_details/${post.id}`
              }, {
                default: _withCtx(() => [
                  _createVNode(ArticalItem, { item: post }, null, 8, ["item"])
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(ArticalSkeleton, { class: "artical-item" }),
          _createVNode(ArticalSkeleton, { class: "artical-item artical-hidden" })
        ])),
    (!_unref(postsData).loadingPosts)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_unref(postsData)?.total_records == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, "コミュニティサイト記事はありません"))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(Pagination, {
              totalDataOfPage: _unref(postsData)?.total_records,
              totalPage: _unref(postsData)?.total_pages
            }, null, 8, ["totalDataOfPage", "totalPage"]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(SelectCustom, {
                options: dataSelectRecordPerPage.value,
                keyName: 'page_of_number',
                disabled: _unref(postsData)?.total_records == 0
              }, null, 8, ["options", "disabled"])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})